import React from "react";

export default function AmbientParticles() {
  return (
    <div className="fixed inset-0 pointer-events-none z-[1] overflow-hidden">
      {Array.from({ length: 20 }).map((_, i) => (
        <div
          key={i}
          className="ambient-particle absolute rounded-full bg-white/[0.03]"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            width: `${Math.random() * 4 + 1}px`,
            height: `${Math.random() * 4 + 1}px`,
            animationDelay: `${Math.random() * 15}s`,
            animationDuration: `${Math.random() * 20 + 15}s`,
          }}
        />
      ))}
      <style jsx>{`
        .ambient-particle { animation: ambient-float linear infinite; }
        @keyframes ambient-float {
          0% { transform: translateY(0) translateX(0); opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { transform: translateY(-100vh) translateX(0px); opacity: 0; }
        }
      `}</style>
    </div>
  );
}